import { render, staticRenderFns } from "./Akkordeon.vue?vue&type=template&id=e7dd8628&scoped=true&"
import script from "./Akkordeon.vue?vue&type=script&lang=js&"
export * from "./Akkordeon.vue?vue&type=script&lang=js&"
import style0 from "./Akkordeon.vue?vue&type=style&index=0&id=e7dd8628&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7dd8628",
  null
  
)

export default component.exports